















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import BigItemCard from '@/components/item-cards/BigItemCard.vue';
import BigListCoverCard from '@/components/BigListCoverCard.vue';
import BigListEndCard from '@/components/BigListEndCard.vue';
import AddItemButtons from '@/components/AddItemButtons.vue';
import NavigationDots from '@/components/NavigationDots.vue';
import ListSaveWidget from '@/components/ListSaveWidget.vue';
import ListDetailFooter from '@/components/ListDetailFooter.vue';
import UserAvatar from '@/components/UserAvatar.vue';

import * as _ from 'lodash';
import * as $ from 'jquery';

import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';

import { UserModule, UserStore } from '@/store/modules/user';

import moment from 'moment';

import { BaseListView } from '@/views/BaseListView';

import queryString from 'query-string';
import { parse } from 'libphonenumber-js';

@Component({
  components: {
    BigItemCard,
    AddItemButtons,
    NavigationDots,
    ListSaveWidget,
    BigListCoverCard,
    BigListEndCard,
    ListDetailFooter,
    UserAvatar
  },
  async beforeRouteEnter(to: any, from: any, next: any): Promise<any> {
    if (from.name == null) {
      next((vm: ListDetailView) => {
        vm.onClose = () => {
          vm.$router.push('/');
        };
      });
    } else {
      next((vm: ListDetailView) => {
        vm.onClose = () => {
          vm.$router.go(-1);
        };
      });
    }
  }
})
export default class ListDetailView extends BaseListView {
  public isMobileView: boolean = false;
  public currentSlide: number = 0;
  itemsLoaded = false;
  showDebugInfo: boolean = false;
  onClose: () => void = undefined;

  public glideRunCallback(arg: any) {
    // @ts-ignore
    this.currentSlide = this.$refs.glide.glide.index;
    Vue.nextTick(() => {
      // @ts-ignore
      $('body').scrollTop(0);
    });

    if (this.currentSlide == 0 || this.currentSlide >= this.items.length) {
      history.replaceState(history.state, '', '#');
    } else {
      history.replaceState(
        history.state,
        '',
        `#item=${this.items[this.currentSlide - 1].id}`
      );
    }
  }

  public goToPage(pattern: string) {
    // @ts-ignore
    this.$refs.glide.glide.go(pattern);
  }

  public created() {
    this.loadList();
  }

  onListLoaded() {
		console.log('list loaded')
    if (this.list.isPrivate && !this.canEditList) {
      this.$router.replace('/404');
    }
    if (!this.list.isListed && !this.canEditList) {
      this.$router.replace('/404');
    }

    if (
      (this.slug &&
        this.username &&
        (this.slug != this.list.slug || this.username != this.list.username)) ||
      this.listId
    ) {
      let link = this.list.link;
      if (document.location.hash.length > 1) {
        link += document.location.hash;
      }
      this.$router.replace(link);
    }

    this.setMetaTags();

    this.loadItems();
  }

  get title() {
    return `mixlet: ${this.list.title} - ${this.list.username}`;
  }

  get coverImage() {
    return this.getImages(1)[0] || null;
  }

  onItemsLoaded() {
    this.itemsLoaded = true;
    const parsedHash = queryString.parse(location.hash);

    // @ts-ignore;
    Vue.nextTick(this.reGlide.bind(this));

    if (parsedHash['item']) {
      const onDesktop =
        window.getComputedStyle(
          document.getElementsByClassName('hide-on-desktop')[0]
        ).display === 'none';
      if (onDesktop) {
        Vue.nextTick(() =>
          document.getElementById(parsedHash['item'] as string).scrollIntoView()
        );
      } else {
        const itemIndex = this.items.findIndex(
          item => item.id === parsedHash['item']
        );
        // const self = this;
        if (itemIndex > -1) {
          Vue.nextTick(() => {
            // @ts-ignore
            this.$refs.glide.glide.go('=' + (itemIndex + 1));
          });
        }
      }
    }
  }

  reGlide() {
    // @ts-ignore
    this.$refs.glide.glide.destroy();
    // @ts-ignore
    this.$refs.glide.glide.mount();
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }

  get isAdmin() {
    return UserModule.userProfile && UserModule.userProfile.isAdmin;
  }

  setIsHighlighted() {
    ListModelUtil.setIsHighlighted(this.list.id, !this.list.isHighlighted);
  }

  get meta() {
    if (!this.list) {
      return [];
    }
    return [
      // OpenGraph data (Most widely used)
      // @ts-ignore
      { property: 'og:title', content: this.title },
      { property: 'og:site_name', content: 'mixlet' },
      // The list of types is available here: http://ogp.me/#types
      { property: 'og:type', content: 'website' },
      // Should the the same as your canonical link, see below.
      // {property: 'og:url', content: 'https://www.my-site.com/my-special-page'},
      {
        property: 'og:image',
        // @ts-ignore
        content: this.coverImage
      },
      // Often the same as your meta description, but not always.
      // @ts-ignore
      { property: 'og:description', content: this.list.description },

      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      // {
      //   name: 'twitter:site',
      //   content: 'https://www.my-site.com/my-special-page'
      // },
      // @ts-ignore
      { name: 'twitter:title', content: this.title },
      {
        name: 'twitter:description',
        // @ts-ignore
        content: this.list.description
      },
      // Your twitter handle, if you have one.
      { name: 'twitter:creator', content: this.list.username },
      { name: 'twitter:site', content: '@getmixlet' },
      {
        name: 'twitter:image:src',
        // @ts-ignore
        content: this.coverImage
      },

      // Google / Schema.org markup:
      // @ts-ignore
      { itemprop: 'name', content: this.title },
      // @ts-ignore
      { itemprop: 'description', content: this.list.description },
      {
        itemprop: 'image',
        // @ts-ignore
        content: this.coverImage
      }
    ];
  }

  setMetaTags() {
    const headEl = document.getElementsByTagName('head')[0];
    this.meta.forEach(metaVal => {
      //<meta property="og:locale" content="en_GB" />
      const metaTag = document.createElement('meta');
      for (const key in metaVal) {
        // @ts-ignore
        metaTag.setAttribute(key, metaVal[key]);
      }
      headEl.append(metaTag);
    });
  }
}
